import { render, staticRenderFns } from "./AuthorityUpsertProvider.vue?vue&type=template&id=52077a35&scoped=true&"
import script from "./AuthorityUpsertProvider.vue?vue&type=script&lang=ts&"
export * from "./AuthorityUpsertProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52077a35",
  null
  
)

export default component.exports